import { _ } from "libs";
import moment from "moment";

export function prettyDate(unixTimestamp, showTime = true) {
	let day = moment.unix(unixTimestamp).format("dddd");
	let time = moment.unix(unixTimestamp).format("HH:mm");
	let today = moment()
		.endOf("day")
		.unix();
	let tomorrow = moment()
		.add(1, "day")
		.endOf("day")
		.unix();
	if (
		today ===
		moment
			.unix(unixTimestamp)
			.endOf("day")
			.unix()
	) {
		day = _("today");
	}
	if (
		tomorrow ===
		moment
			.unix(unixTimestamp)
			.endOf("day")
			.unix()
	) {
		day = _("tomorrow");
	}
	if (unixTimestamp > unixTimestamp + 6 * 24 * 3600) {
		day = moment.unix(unixTimestamp).format("ddd D MMM");
	}
	if (unixTimestamp < Math.floor(Date.now() / 1000)) {
		day = moment.unix(unixTimestamp).format("D MMM");
	}
	return showTime ? day + ", " + time : day;
}
